import { authentication } from 'src/utilities/storage';
import { USER_LOGIN_TIMEOUT_MANAGE_READ } from 'src/features/RBAC/Rules/permissionData';
import { find, pathOr, propEq } from 'ramda';

class UserManageLoader {
    permissions?: any;

    constructor(permissions?: any) {
        this.permissions = permissions;
    }
    setLoggedInTime(previousLoginTime?: Number) {
        const loggedInTime = previousLoginTime || new Date().getTime();
        return authentication.loginTime.set(loggedInTime);
    }
    getLoggedInTime() {
        return Number(authentication.loginTime.get());
    }

    setInActiveTime() {
        const inActiveTime = new Date().getTime();
        return authentication.inActiveTime.set(inActiveTime);
    }

    getInActiveTime() {
        return Number(authentication.inActiveTime.get());
    }
    /**
 * Retrieves the expiration time for user sessions.
 * 
 * By default, the expiration time is set to 60 minutes. If autologout is enabled for a user
 * but if the timeout permission is not properly configured, the user may experience frequent logouts.
 * In such cases, the default expiration time has been changed to 60 (1 Hour)
 * 
 * @returns The expiration time for user sessions in milliseconds.
 */
    getExpiredTime() {
        // 1 hour = 60 minutes * 60 seconds * 1000 milliseconds
        const expiredTime = pathOr('60', ['timeout', 'expired'], this.getTimeoutDetails());
        const time = Number(expiredTime) * 60 * 1000;
        return time;
    }


    getWarningTime() {
        // 1 hour = 55 minutes * 60 seconds * 1000 milliseconds
        const warningTime = pathOr('55', ['timeout', 'warning'], this.getTimeoutDetails());
        const time = Number(warningTime) * 60 * 1000;
        return time;
    }
    
    checkSessionTimeoutWarning() {
        const loginTime = this.getLoggedInTime();
        const now = new Date().getTime();
        if (now - loginTime > this.getWarningTime()) {
            return true;
        }
        return false;
    }

    checkPageIdle(logoutTime: string) {
        const inActiveTime = this.getInActiveTime();
        const now = new Date().getTime();
        const IdleTime = Number(logoutTime) * 60 * 1000;
        if (now - inActiveTime > IdleTime) {
            return true;
        }
        return false;
    }

    checkSessionTimeout() {
        const loginTime = this.getLoggedInTime();
        const now = new Date().getTime();
        if (loginTime && now - loginTime > this.getExpiredTime()) {
            return true;
        }

        return false;
    }

    getRemainingTime() {
        const expiredTime = this.getExpiredTime();
        const loggedInTime = this.getLoggedInTime();
        const endTime = new Date(loggedInTime + expiredTime);
        const expiredSeconds = endTime.getTime();
        const currentDate = new Date();
        const currentSeconds = currentDate.getTime();
        const remainingSeconds = expiredSeconds - currentSeconds;
        return Math.floor(remainingSeconds);
    }

    getTimeoutDetails() {
        const timeoutPermission = find(
            propEq('name', USER_LOGIN_TIMEOUT_MANAGE_READ),
            this.permissions
        );
        const timeout = pathOr({}, ['options', 'timeout'], timeoutPermission);
        return {
            timeout
        }
    }
}
export default UserManageLoader;